var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import lightGallery from 'lightgallery';
export class CarouselComponent extends Component {
    constructor() {
        super('CarouselComponent', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            CarouselComponent.resizeCaptions();
            CarouselComponent.resizeControls();
            $(window).on('resize', () => {
                CarouselComponent.resizeCaptions();
                CarouselComponent.resizeControls();
            });
            $('.carousel').each((carousel) => {
                if (!carousel.hasClass('carousel-zoomable'))
                    return;
                lightGallery(carousel.get(0), {
                    selector: '.carousel-item .image',
                    download: false,
                    enableDrag: false,
                    counter: false,
                    licenseKey: '50D5F6D5-C8A04CC9-B91F3F10-F85C3707',
                    mobileSettings: {
                        controls: true,
                        showCloseIcon: true,
                        download: false,
                        counter: false,
                        enableDrag: false,
                    }
                });
            });
            this.success();
        });
    }
    static resizeCaptions() {
        $('.carousel').each((carousel) => {
            carousel.find('.carousel-item').removeClass('active');
            carousel.find('.carousel-caption').css('height', 'auto');
            let captionMaxHeight = 0;
            carousel.find('.carousel-caption').each((caption) => {
                caption.parent().addClass('active');
                if (caption.height() > captionMaxHeight)
                    captionMaxHeight = caption.height();
            });
            carousel.find('.carousel-caption').css('height', captionMaxHeight);
            carousel.find('.carousel-item').removeClass('active').first().addClass('active');
        });
    }
    static resizeControls() {
        $('.carousel').each((carousel) => {
            carousel.find('.carousel-control-prev, .carousel-control-next').css('top', carousel.find('.carousel-item.active .image').height() / 2);
            carousel.find('.carousel-zoom-icon').css('top', carousel.find('.carousel-item.active .image').height() - 50);
        });
    }
}
